import React from "react";

class Errors extends React.Component {
  render() {
    const { errors, ...rest } = this.props;

    return errors.length > 0 && (
      <div className="e-coupon-errors" {...rest}>
        {errors.map((error, i) => <span className="e-coupon-errors__error" key={i}>{error}</span>)}
      </div>
    );
  }
}

export default Errors;


// WEBPACK FOOTER //
// ./app/components/EsportsGame/ECoupon/Errors.jsx